var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6755 7.75156L17.2323 0.553223H15.6785L9.98524 6.80344L5.43803 0.553223H0.193359L7.06963 10.0047L0.193359 17.5532H1.7472L7.75946 10.9528L12.5616 17.5532H17.8063L10.6751 7.75156H10.6755ZM8.54726 10.0879L7.85055 9.14678L2.30708 1.65794H4.69369L9.16734 7.70167L9.86405 8.64282L15.6793 16.4987H13.2926L8.54726 10.0883V10.0879Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "white",
    transform: "translate(0 0.553223)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.41f6211f92675f5fec67e70ae3008356.svg";
export { ForwardRef as ReactComponent };